<template>
  <div class="contas-de-usuario">
    <h1 class="titulo-card fs-4">Contas de usuário</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="handleAdicionar()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'plus']" fixed-width class="me-1"/>Adicionar
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="handlePesquisa()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="handlePesquisa()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <table class="table table-sm-pc table-striped table-hover">
          <thead>
            <tr>
              <th width="25">#</th>
              <th>Identificação</th>
              <th>E-mail</th>
              <th>Login</th>
              <th width="110"></th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="usuario in listaUsuarios" :key="usuario.id">
                <td scope="row">{{usuario.id}}</td>
                <td>
                  {{usuario.nome}}
                  <span class="text-muted-2">{{nomeRedeNeutra(usuario.parceiro_rede_neutra_id)}}</span>
                </td>
                <td>{{usuario.email}}</td>
                <td>{{usuario.login}}</td>
                <td class="text-end">
                  <button type="button" v-on:click="modalTrocaSenhaHandleAbre(usuario)" class="btn btn-outline-secondary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'key']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleEditaUsuario(usuario)" class="btn btn-primary btn-sm me-1">
                    <font-awesome-icon :icon="['fas', 'edit']" fixed-width/>
                  </button>
                  <button type="button" v-on:click="handleRemoveUsuario(usuario)" class="btn btn-danger btn-sm">
                    <font-awesome-icon :icon="['fas', 'times']" fixed-width/>
                  </button>
                </td>

              </tr>
            </tbody>
        </table>
      </div>
      <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>

      <!-- modal-edita-usuario -->
      <!-- Button trigger modal -->
      <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-edita-usuario" id="btn-modal-edita-usuario-abre">
        Launch
      </button>

      <!-- Modal -->
      <div class="modal fade" id="modal-edita-usuario" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="!modalUsuario.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
                Cadastrar novo usuário
              </h5>
              <h5 v-if="!!modalUsuario.data.id" class="modal-title">
                <font-awesome-icon :icon="['fas', 'pen']" fixed-width/>
                Editando usuário
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-check form-switch">
                    <input v-model="modalUsuario.data.ativo" class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                    <label class="form-check-label" for="flexSwitchCheckDefault">Ativo</label>
                  </div>
                </div>
                <div v-if="(parceirosRedeNeutra && parceirosRedeNeutra.length > 0)" class="col-12 col-sm-3">
                  <label class="required">Parceiro de rede neutra</label>
                  <select v-model="modalUsuario.data.parceiro_rede_neutra_id" class="form-control">
                    <option :value="0">Nenhum</option>
                    <option v-for="x in parceirosRedeNeutra" :key="x.id" :value="x.id">{{x.descricaoCurta}}</option>
                  </select>
                </div>
                <div class="col-12 col-sm-3">
                  <label class="required">Identificação</label>
                  <input type="text" v-model="modalUsuario.data.nome" class="form-control">
                </div>
                <div class="col-12 col-sm-3">
                  <label class="required">E-mail</label>
                  <input type="text" v-model="modalUsuario.data.email" class="form-control">
                </div>
                <div class="col-12 col-sm-3">
                  <label class="required">Login</label>
                  <input type="text" v-model="modalUsuario.data.login" class="form-control">
                </div>
                <div class="col-12 col-sm-3">
                  <label class="required">Grupo Helpdesk</label>
                  <select type="text" v-model="modalUsuario.data.helpdesk_grupo_id" class="form-select">
                    <option :value="0">Nenhum</option>
                    <option v-for="grupo in listaGruposHelpdesk" :key="grupo.id" :value="grupo.id">{{grupo.descricao}}</option>
                  </select>
                </div>
              </div>
              <div v-show="!modalUsuario.data.id" class="row">
                <div class="col-12 col-sm-4">
                  <label class="required">Senha</label>
                  <input type="text" v-model="modalUsuario.senha" class="form-control">
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-edita-usuario-fecha">Fechar</button>
              <button type="button"
                  v-if="!modalUsuario.data.id"
                  v-on:click="handlemodalUsuarioCadastrar()"
                  v-bind:disabled="!podeSalvarUsuario()"
                  class="btn btn-success">
                Cadastrar
              </button>
              <button type="button"
                  v-if="!!modalUsuario.data.id"
                  v-on:click="handlemodalUsuarioSalvar()"
                  v-bind:disabled="!podeSalvarUsuario()"
                  class="btn btn-success">
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-edita-usuario -->

    <!-- modal-troca-senha-usuario -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-troca-senha-usuario" id="btn-modal-troca-senha-usuario-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-troca-senha-usuario" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <font-awesome-icon :icon="['fas', 'key']" fixed-width/>
              Trocar senha do usuário
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <h6>
              <font-awesome-icon :icon="['fas', 'user']" fixed-width/>
              {{modalTrocaSenha.usuario ? modalTrocaSenha.usuario.nome : ''}}
            </h6>
            <div class="row">
              <div class="col-12 col-sm-6">
                <label class="required">Senha</label>
                <input type="password" v-model="modalTrocaSenha.data.senha" class="form-control">
              </div>
              <div class="col-12 col-sm-6">
                <label class="required">Confirmação</label>
                <input type="password" v-model="modalTrocaSenha.data.confirmacao_senha" class="form-control">
                <p v-if="modalTrocaSenha.data.senha !== modalTrocaSenha.data.confirmacao_senha"
                    class="mb-0 text-danger small">
                  As senhas não conferem
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-troca-senha-usuario-fecha">Fechar</button>
            <button type="button"
                v-on:click="modalTrocaSenhaSalvarHandle()"
                v-bind:disabled="!modalTrocaSenhaPodeSalvar()"
                class="btn btn-success">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-troca-senha-usuario -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'

export default {
  name: 'ContasDeUsuario',
  components: {
    Paginador,
  },
  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      listaUsuarios: [],
      listaIPPools: [],
      listaGruposHelpdesk: [],
      parceirosRedeNeutra: [],
      modalUsuario: {
        senha: '',
        data: {
          id: undefined,
          parceiro_rede_neutra_id: 0,
          nome: '',
          email: '',
          login: '',
          helpdesk_grupo_id: 0,
        },
      },
      modalTrocaSenha: {
        usuario: undefined,
        data: {
          id: undefined,
          senha: '',
          confirmacao_senha: '',
        },
      }
    }
  },
  methods: {
    handlePesquisa() {
      loading(true);

      api.get(`/usuarios?${this.paginador.requestParams}`).then(res => {
        loading(false);
        this.listaUsuarios = res.data.itens;
        this.paginador.pagina = res.data.paginacao.pagina;
        this.paginador.totalItens = res.data.paginacao.total;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    onChangePaginacao() {
      this.handlePesquisa();
    },

    handleAdicionar() {
      this.resetModalUsuario();
      this.abreModalCadastroUsuario();
    },

    async handleEditaUsuario(usuario) {
      this.resetModalUsuario();

      this.modalUsuario.data = clone(usuario);

      this.abreModalCadastroUsuario();
    },

    handleRemoveUsuario(usuario) {
      dialogo.confirmacao(`Confirma remover o usuário <b>${usuario.nome}</b>?`).then(() => {
        loading(true);

        api.delete(`/usuarios/${usuario.id}`).then(() => {
          loading(false);

          this.handlePesquisa();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },

    carregaGrupos() {
      api.get(`/helpdesk/grupos?paginacao.porPagina=-1&orderBy[prioridade]=desc`).then(res => {
        this.listaGruposHelpdesk = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaGrupos();
        }, 1000);
      });
    },

    carregaParceirosRedeNeutra() {
      api.get(`/rede-neutra/parceiros?paginacao.porPagina=-1&orderBy[descricao_curta]=asc`).then(res => {
        this.parceirosRedeNeutra = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaGrupos();
        }, 1000);
      });
    },

    nomeRedeNeutra(parceiroID) {
      const parceiro = this.parceirosRedeNeutra.find(x => x.id === parceiroID);
      if (parceiro) {
        return `(${parceiro.descricaoCurta})`;
      }

      return '';
    },

    //MODAL EDIT
    abreModalCadastroUsuario() {
      document.getElementById('btn-modal-edita-usuario-abre').click();
    },

    resetModalUsuario() {
      this.modalUsuario.data.id = undefined;
      this.modalUsuario.data.parceiro_rede_neutra_id = 0;
      this.modalUsuario.data.nome = '';
      this.modalUsuario.data.email = '';
      this.modalUsuario.data.login = '';
      this.modalUsuario.senha = '';
      this.modalUsuario.helpdesk_grupo_id = 0;
    },

    podeSalvarUsuario() {
      const senhaInvalida =
          (!this.modalUsuario.data.id) && (!this.modalUsuario.senha);

      switch (true) {
        case (this.modalUsuario.data.nome.length < 3):
        case (this.modalUsuario.data.email.length < 7):
        case (this.modalUsuario.data.login.length < 3):
        case (senhaInvalida):
          return false;

        default:
          return true;
      }
    },

    handlemodalUsuarioCadastrar() {
      const sendData = clone(this.modalUsuario.data);
      sendData.senha = this.modalUsuario.senha;

      loading(true);

      api.post('/usuarios', sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-usuario-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    handlemodalUsuarioSalvar() {
      const sendData = clone(this.modalUsuario.data);

      loading(true);
      api.put(`/usuarios/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-edita-usuario-fecha').click();
        this.handlePesquisa();
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
    //MODAL EDIT


    //MODAL TROCA SENHA
    modalTrocaSenhaHandleAbre(usuario) {
      this.modalTrocaSenhaReset();

      this.modalTrocaSenha.usuario = clone(usuario);

      this.modalTrocaSenhaAbre();
    },

    modalTrocaSenhaReset() {
      this.modalTrocaSenha.usuario = undefined;
      this.modalTrocaSenha.data.id = undefined;
      this.modalTrocaSenha.data.senha = '';
      this.modalTrocaSenha.data.confirmacao_senha = '';
    },

    modalTrocaSenhaAbre() {
      document.getElementById('btn-modal-troca-senha-usuario-abre').click();
    },

    modalTrocaSenhaPodeSalvar() {
      switch (true) {
        case (this.modalTrocaSenha.data.senha.length < 1):
        case (this.modalTrocaSenha.data.senha !== this.modalTrocaSenha.data.confirmacao_senha):
          return false;

        default:
          return true;
      }
    },

    modalTrocaSenhaSalvarHandle() {
      const sendData = {
        id: this.modalTrocaSenha.usuario.id,
        senha: this.modalTrocaSenha.data.senha
      };

      loading(true);
      api.patch(`/usuarios/${sendData.id}`, sendData).then(() => {
        loading(false);
        document.getElementById('btn-modal-troca-senha-usuario-fecha').click();
        this.handlePesquisa();
        dialogo.alerta('A nova senha foi definida com sucesso.');
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },
    //MODAL TROCA SENHA
  },

  created() {
    this.handlePesquisa();
    this.carregaGrupos();
    this.carregaParceirosRedeNeutra();
  }
}
</script>
